import _     from 'lodash';
import Model from 'alto-orm/lib/orm/model';

export default class Product extends Model {
  static nominativeName = 'produkt';
  static accusativeName = 'produkt';
};
